module.exports = __webpack_public_path__ + "static/181-7a8494af461e17b6c4b3bc41dd4b24cc.png";